import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["socialNetworksUrls"];
import { createImmutableSliceSelector, createImmutableSelector } from './utils';
import pick from 'transmute/pick';
import { selectPrimaryLanguage } from '../knowledge-base/selectors/knowledgeBaseDetails';
const MASTER_LANG_SYNC_PROPERTIES = ['companyWebsiteLink', 'companyWebsiteLinkText', 'footerLinks', 'footerMessage', 'name', 'socialNetworksUrls', 'supportFormId', 'supportFormTitle', 'welcomeMessage'];
export const selectTemplateSettings = createImmutableSliceSelector('templateSettings');
export const selectKnowledgeBaseSettings = createImmutableSelector([selectTemplateSettings], templateSettings => templateSettings.get('knowledgeBaseSettings'));
export const selectHasPrivateArticles = createImmutableSelector([state => state.articleCounts], countsData => countsData.getIn(['counts', 'PUBLISHED']));
export const selectTemplateTranslations = createImmutableSliceSelector('templateTranslations');
const selectTemplateEditorNavigationContext = createImmutableSliceSelector('templateEditorNavigationContext');
export const selectTemplateEditorLanguage = createImmutableSelector([selectTemplateEditorNavigationContext], navigationContext => navigationContext.selectedLanguage);
export const selectIsViewingTemplateEditorLanguageVariation = createImmutableSelector([selectTemplateEditorLanguage, selectPrimaryLanguage], (templateEditorLanguage, primaryLanguage) => templateEditorLanguage !== primaryLanguage);
const selectHomepageCategoriesSettings = createImmutableSliceSelector('homepageCategoriesSettings');
const selectTemplatePreviewPlaceholders = state => state.templatePreviewPlaceholders;
const selectTheme = state => state.theme;
const selectTemplatePreviewTemplateSettings = createImmutableSelector([selectTemplateSettings, selectTemplateTranslations, selectTemplateEditorLanguage], (templateSettings, templateTranslations, language) => {
  if (!templateTranslations.get('lastLoaded') || language === templateSettings.getIn(['knowledgeBaseSettings', 'language'])) {
    return templateSettings;
  }
  const translationsForLanguage = templateTranslations.getIn(['data', language]);
  if (!translationsForLanguage) {
    return templateSettings;
  }
  return templateSettings.update('knowledgeBaseSettings', settings => {
    const _translationsForLangu = translationsForLanguage.toJS(),
      {
        socialNetworksUrls
      } = _translationsForLangu,
      otherValues = _objectWithoutPropertiesLoose(_translationsForLangu, _excluded);
    return settings.merge(Object.assign({}, otherValues, {
      socialNetworkUrls: socialNetworksUrls
    }));
  });
});
export const selectTemplatePreviewStoreSlice = createImmutableSelector([selectHomepageCategoriesSettings, selectTemplateEditorNavigationContext, selectTemplatePreviewPlaceholders, selectTemplatePreviewTemplateSettings, selectTheme], (homepageCategoriesSettings, templateEditorNavigationContext, templatePreviewPlaceholders, templateSettings, theme) => ({
  homepageCategoriesSettings,
  templateEditorNavigationContext,
  templatePreviewPlaceholders,
  templateSettings,
  theme
}));
export const selectSyncedTranslations = createImmutableSelector([selectTemplateTranslations, selectKnowledgeBaseSettings, selectPrimaryLanguage], (translations, kbSettings, primaryLanguage) => {
  if (!translations.get('data')) return translations;
  return translations.set('data', translations.get('data').mergeDeep({
    [primaryLanguage]: pick(MASTER_LANG_SYNC_PROPERTIES, kbSettings.toJS())
  }));
});